export const NODES_CLASSEUR_EDIT = [
  {
    key: "1",
    label: "Propriété & Foncier",
    children: [
      { key: "1-10", label: "Titres & actes" },
      { key: "1-11", label: "Estimations & valeurs" },
      { key: "1-12", label: "Plans & bornage" },
      { key: "1-13", label: "Servitudes" },
      { key: "1-14", label: "Publicité & Foncier" },
      { key: "1-15", label: "Projets & acquisitions" },
    ],
  },
  {
    key: "2",
    label: "Urbanisme & Planification",
    children: [
      { key: "2-20", label: "Documents réglementaires" },
      { key: "2-21", label: "Permis & autorisations" },
      { key: "2-22", label: "Suivi de chantier" },
    ],
  },
  {
    key: "3",
    label: "Copropriété & Associations",
    children: [
      { key: "3-30", label: "Assemblées générales" },
      { key: "3-31", label: "Correspondances" },
      { key: "3-32", label: "Réglementation" },
      { key: "3-33", label: "Note de service" },
      { key: "3-34", label: "Vie collective & services" },
    ],
  },
  {
    key: "4",
    label: "Gestion locative",
    children: [
      { key: "4-40", label: "Contrat" },
      { key: "4-41", label: "Etats des lieux" },
      { key: "4-42", label: "Loyers & charges" },
    ],
  },
  { key: "5", label: "Fiscalité", children: [{ key: "5-50", label: "Fiscalité" }] },
  { key: "6", label: "Financement", children: [{ key: "6-60", label: "Financement" }] },
  {
    key: "7",
    label: "Assurances",
    children: [
      { key: "7-70", label: "Contrats" },
      { key: "7-71", label: "Sinistres" },
    ],
  },
  {
    key: "8",
    label: "Travaux & Entretien",
    children: [
      { key: "8-80", label: "Etudes & estimations" },
      { key: "8-81", label: "Devis" },
      { key: "8-82", label: "Contrat" },
      { key: "8-83", label: "Factures & honoraires" },
      { key: "8-84", label: "Bordereau de livraison" },
      { key: "8-85", label: "Fiche d'intervention" },
      { key: "8-86", label: "Demande d'intervention" },
      { key: "8-87", label: "Réception & garanties" },
    ],
  },
  {
    key: "9",
    label: "Diagnostics & Etudes techniques",
    children: [
      {
        key: "9-90",
        label: "Diagnostics obligatoires",
        children: [
          {
            key: "9-90-1",
            label: "Amiante",
            children: [
              {
                key: "9-90-1-10",
                label: "Dossier amiante",
                children: [
                  { key: "9-90-1-10-11", label: "Rapport de diagnostic" },
                  { key: "9-90-1-10-12", label: "Fiche récapitulative" },
                  { key: "9-90-1-10-13", label: "Annexes" },
                ],
              },
            ],
          },
          { key: "9-90-2", label: "DPE" },
          { key: "9-90-3", label: "Plomb" },
        ],
      },
      { key: "9-91", label: "Sécurité & risques" },
      { key: "9-92", label: "Accessibilité" },
      { key: "9-93", label: "Etudes de sols" },
    ],
  },
  { key: "10", label: "Plans & Techniques", children: [{ key: "10-100", label: "Plans & Techniques" }] },
  { key: "11", label: "Litiges & Contentieux", children: [{ key: "11-110", label: "Litiges & contentieux" }] },
  { key: "12", label: "Gouvernance", children: [{ key: "12-120", label: "Conseil d'administration" }] },
];

export const NODES_CLASSEUR_ADD = [
  {
    key: "1",
    label: "Propriété & Foncier",
    children: [
      { key: "1-10", label: "Titres & actes" },
      { key: "1-11", label: "Estimations & valeurs" },
      { key: "1-12", label: "Plans & bornage" },
      { key: "1-13", label: "Servitudes" },
      { key: "1-14", label: "Publicité & Foncier" },
      { key: "1-15", label: "Projets & acquisitions" },
    ],
  },
  {
    key: "2",
    label: "Urbanisme & Planification",
    children: [
      { key: "2-20", label: "Documents réglementaires" },
      { key: "2-21", label: "Permis & autorisations" },
      { key: "2-22", label: "Suivi de chantier" },
    ],
  },
  {
    key: "3",
    label: "Copropriété & Associations",
    children: [
      { key: "3-30", label: "Assemblées générales" },
      { key: "3-31", label: "Correspondances" },
      { key: "3-32", label: "Réglementation" },
      { key: "3-33", label: "Note de service" },
      { key: "3-34", label: "Vie collective & services" },
    ],
  },
  {
    key: "4",
    label: "Gestion locative",
    children: [
      { key: "4-40", label: "contrat" },
      { key: "4-41", label: "Etats des lieux" },
      { key: "4-42", label: "Loyers & charges" },
    ],
  },
  { key: "5", label: "Fiscalité", children: [{ key: "5-50", label: "Fiscalité" }] },
  { key: "6", label: "Financement", children: [{ key: "6-60", label: "Financement" }] },
  {
    key: "7",
    label: "Assurances",
    children: [
      { key: "7-70", label: "Contrats" },
      { key: "7-71", label: "Sinistres" },
    ],
  },
  {
    key: "8",
    label: "Travaux & Entretien",
    children: [
      { key: "8-80", label: "Etudes & estimations" },
      { key: "8-81", label: "Devis" },
      { key: "8-82", label: "Contrat" },
      { key: "8-83", label: "Factures & honoraires" },
      { key: "8-84", label: "Bordereau de livraison" },
      { key: "8-85", label: "Fiche d'intervention" },
      { key: "8-86", label: "Demande d'intervention" },
      { key: "8-87", label: "Réception & garanties" },
    ],
  },
  {
    key: "9",
    label: "Diagnostics & Etudes techniques",
    children: [
      {
        key: "9-90",
        label: "Diagnostics obligatoires",
        children: [
          {
            key: "9-90-1",
            label: "Amiante",
            children: [
              {
                key: "9-90-1-10",
                label: "Dossier amiante",
                children: [
                  { key: "9-90-1-10-11", label: "Rapport de diagnostic" },
                  { key: "9-90-1-10-12", label: "Fiche récapitulative" },
                  { key: "9-90-1-10-13", label: "Annexes" },
                ],
              },
            ],
          },
          { key: "9-90-2", label: "DPE" },
          { key: "9-90-3", label: "Plomb" },
        ],
      },
      { key: "9-91", label: "Sécurité & risques" },
      { key: "9-92", label: "Accessibilité" },
      { key: "9-93", label: "Etudes de sols" },
    ],
  },
  { key: "10", label: "Plans & Techniques", children: [{ key: "10-100", label: "Plans & Techniques" }] },
  { key: "11", label: "Litiges & Contentieux", children: [{ key: "11-110", label: "Litiges & contentieux" }] },
  { key: "12", label: "Gouvernance", children: [{ key: "12-120", label: "Conseil d'administration" }] },
];
